import { cleanupFaultFeedingPortsOnDelete } from '@diagram/state/effects/diagram/cleanup-fault-feeding-ports-on-delete';
import { syncComponentGenericVoltageTypes } from '@diagram/state/effects/diagram/sync-component-generic-voltage-types';
import { syncConnectionInstallationMethod } from '@diagram/state/effects/diagram/sync-connection-installation-method';
import { syncTwoPortConverterPower } from '@diagram/state/effects/diagram/sync-two-port-converter-power';

const SideEffects = {
    cleanupFaultFeedingPortsOnDelete,
    syncComponentGenericVoltageTypes,
    syncConnectionInstallationMethod,
    syncTwoPortConverterPower,
} as const;

export { SideEffects };
